import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import Lightbox from 'react-images'
import { CircleLoader } from 'components/loaders'
import { apiDownloadFile } from 'helpers/decorators/api'

@apiDownloadFile()
class Image extends PureComponent {
  static propTypes = {
    src: PropTypes.string,
    onDownloadFile: PropTypes.func,
    downloadedFile: PropTypes.string,
    files: PropTypes.object
  }

  state = {
    downloadedFile: '',
    isOpen: false,
    loading: false
  }

  componentDidMount() {
    this.props.onDownloadFile(this.props.src)
  }

  handleOpenLightbox = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handleCloseLightbox = () => {
    this.setState({
      isOpen: false
    })
  }

  render() {
    const { isOpen } = this.state
    const { downloadedFile, files, src } = this.props
    const image = get(files[src], 'fileLocalUrl') || downloadedFile
    const loading = get(files[src], 'loading')

    return (
      <span>
        {loading && <CircleLoader size={30} inline />}
        {!loading &&
          <img src={image} width={100} onClick={this.handleOpenLightbox} />}
        {image &&
          <Lightbox
            images={[{ src: image }]}
            isOpen={isOpen}
            onClose={this.handleCloseLightbox}
            showImageCount={false}
          />}
      </span>
    )
  }
}

export default Image
